// Workout Plans for Functional Strength Building
// Focus: Arms, Shoulders, Chest, Glutes, Thighs

export const workoutPlans = {
  // Monday: Bodyweight Upper Body + Core (5am, 45-60 min)
  monday: {
    name: "Bodyweight Upper Body & Core",
    time: "5:00 AM",
    duration: "45-60 min",
    location: "Home",
    focus: "Arms, Shoulders, Chest",
    exercises: [
      {
        id: 1,
        name: "Push-ups",
        sets: 4,
        reps: "Max (aim for 10-15+)",
        rest: "90 sec",
        notes: "Start on knees if needed. Focus on chest touching ground. Goal: build to 20+ reps",
        progressionTips: "Once you hit 15+ reps, try decline push-ups or diamond push-ups"
      },
      {
        id: 2,
        name: "Pull-ups (or Assisted Pull-ups)",
        sets: 5,
        reps: "Max (currently 2-3)",
        rest: "2-3 min",
        notes: "Use resistance band for assistance if needed. Dead hang between sets to build grip strength",
        progressionTips: "Goal: 5 strict pull-ups by month 2. Add negative pull-ups (slow descent) to build strength"
      },
      {
        id: 3,
        name: "Pike Push-ups",
        sets: 3,
        reps: "8-12",
        rest: "90 sec",
        notes: "Targets shoulders. Hips high in air, head between arms, lower head to ground",
        progressionTips: "Progress to elevated pike push-ups (feet on chair)"
      },
      {
        id: 4,
        name: "Tricep Dips (on chair or bench)",
        sets: 3,
        reps: "10-15",
        rest: "60 sec",
        notes: "Keep elbows close to body. Builds back of arms for 'manly' look",
        progressionTips: "Add weight on lap once you hit 15+ reps"
      },
      {
        id: 5,
        name: "Plank Hold",
        sets: 3,
        reps: "45-60 sec",
        rest: "60 sec",
        notes: "Full body tension, don't let hips sag",
        progressionTips: "Progress to side planks and plank variations"
      },
      {
        id: 6,
        name: "Hanging Knee Raises",
        sets: 3,
        reps: "8-12",
        rest: "60 sec",
        notes: "Hang from pull-up bar, raise knees to chest. Builds core and grip",
        progressionTips: "Progress to straight leg raises"
      }
    ]
  },

  // Tuesday: Planet Fitness - Lower Body & Shoulders (9am, 45-60 min)
  tuesday: {
    name: "Planet Fitness - Legs & Shoulders",
    time: "9:00 AM",
    duration: "45-60 min",
    location: "Planet Fitness",
    focus: "Glutes, Thighs, Shoulders",
    exercises: [
      {
        id: 1,
        name: "Leg Press",
        sets: 4,
        reps: "10-12",
        rest: "90 sec",
        notes: "Start light (90-135 lbs). Feet shoulder-width. Push through heels. Builds thighs and glutes",
        machine: "Leg Press Machine - sit, feet on platform, push away",
        progressionTips: "Add 10-20 lbs per week. Goal: 2x bodyweight (350 lbs)"
      },
      {
        id: 2,
        name: "Romanian Deadlifts (Dumbbells)",
        sets: 4,
        reps: "10-12",
        rest: "90 sec",
        notes: "Start with 25-30 lb dumbbells. Hinge at hips, slight knee bend. BEST for glutes and hamstrings",
        machine: "Dumbbell rack",
        progressionTips: "Increase by 5 lbs per week. Feel the stretch in hamstrings"
      },
      {
        id: 3,
        name: "Goblet Squats",
        sets: 3,
        reps: "12-15",
        rest: "90 sec",
        notes: "Hold one dumbbell at chest (30-40 lbs). Squat deep. Builds thighs and glutes",
        machine: "Dumbbell rack",
        progressionTips: "Work up to 60+ lb dumbbell"
      },
      {
        id: 4,
        name: "Shoulder Press Machine",
        sets: 4,
        reps: "8-12",
        rest: "90 sec",
        notes: "Start light (40-50 lbs). Builds boulder shoulders for manly appearance",
        machine: "Shoulder Press Machine - sit, push handles overhead",
        progressionTips: "Add 5-10 lbs per week. Goal: bodyweight+ (175+ lbs)"
      },
      {
        id: 5,
        name: "Lateral Raise Machine",
        sets: 3,
        reps: "12-15",
        rest: "60 sec",
        notes: "Isolates side delts. Creates shoulder width. Start at 30-40 lbs",
        machine: "Lateral Raise Machine - sit, push arms out to sides",
        progressionTips: "Slow and controlled. Focus on form over weight"
      },
      {
        id: 6,
        name: "Walking Lunges",
        sets: 3,
        reps: "10 per leg",
        rest: "60 sec",
        notes: "Bodyweight or holding dumbbells. Great for glutes and functional strength",
        machine: "Open floor space",
        progressionTips: "Add 15-20 lb dumbbells in each hand"
      }
    ]
  },

  // Wednesday: Bodyweight Lower Body + Cardio (5am, 45-60 min)
  wednesday: {
    name: "Bodyweight Lower Body & Cardio",
    time: "5:00 AM",
    duration: "45-60 min",
    location: "Home/Outside",
    focus: "Glutes, Thighs, Cardio",
    exercises: [
      {
        id: 1,
        name: "Bodyweight Squats",
        sets: 4,
        reps: "20-25",
        rest: "60 sec",
        notes: "Deep squats, chest up, knees tracking over toes",
        progressionTips: "Progress to jump squats or pistol squat progressions"
      },
      {
        id: 2,
        name: "Bulgarian Split Squats",
        sets: 3,
        reps: "12 per leg",
        rest: "60 sec",
        notes: "Back foot elevated on chair/couch. KILLER for glutes and quads",
        progressionTips: "Hold dumbbells or backpack with weight"
      },
      {
        id: 3,
        name: "Glute Bridges",
        sets: 4,
        reps: "15-20",
        rest: "45 sec",
        notes: "Lie on back, drive hips up. Squeeze glutes at top for 2 seconds",
        progressionTips: "Progress to single-leg glute bridges"
      },
      {
        id: 4,
        name: "Walking Lunges",
        sets: 3,
        reps: "15 per leg",
        rest: "60 sec",
        notes: "Long strides, knee doesn't touch ground",
        progressionTips: "Add weight or do jumping lunges"
      },
      {
        id: 5,
        name: "Calf Raises",
        sets: 3,
        reps: "20-25",
        rest: "45 sec",
        notes: "On edge of step, full range of motion",
        progressionTips: "Progress to single-leg calf raises"
      },
      {
        id: 6,
        name: "Running Intervals",
        sets: "8 intervals",
        reps: "1 min fast / 1 min walk",
        rest: "n/a",
        notes: "Finish with 16 min run. Builds endurance and burns fat",
        progressionTips: "Increase fast interval to 90 sec over time"
      }
    ]
  },

  // Thursday: Planet Fitness - Upper Body (9am, 45-60 min)
  thursday: {
    name: "Planet Fitness - Chest, Back, Arms",
    time: "9:00 AM",
    duration: "45-60 min",
    location: "Planet Fitness",
    focus: "Arms, Chest, Back",
    exercises: [
      {
        id: 1,
        name: "Chest Press Machine",
        sets: 4,
        reps: "8-12",
        rest: "90 sec",
        notes: "Start 60-80 lbs. Builds chest to reduce 'soft' appearance. Push explosively, control return",
        machine: "Chest Press Machine - sit, push handles forward",
        progressionTips: "Work up to bodyweight+ (175+ lbs). Goal: hard, defined chest"
      },
      {
        id: 2,
        name: "Seated Cable Row",
        sets: 4,
        reps: "10-12",
        rest: "90 sec",
        notes: "Start 70-90 lbs. Pull to stomach, squeeze shoulder blades. Builds thick back",
        machine: "Seated Row Machine - sit, pull handles to torso",
        progressionTips: "Add 10 lbs per week. Creates V-taper look"
      },
      {
        id: 3,
        name: "Assisted Pull-up Machine",
        sets: 4,
        reps: "6-8",
        rest: "2 min",
        notes: "Use 80-100 lbs assistance. Builds back and arms. Helps reach 5+ pull-up goal",
        machine: "Assisted Pull-up Machine - kneel on platform, pull up",
        progressionTips: "Reduce assistance by 10 lbs each week"
      },
      {
        id: 4,
        name: "Dumbbell Bicep Curls",
        sets: 4,
        reps: "10-12",
        rest: "60 sec",
        notes: "Start 20-25 lbs. Don't swing. Builds arm size",
        machine: "Dumbbell rack",
        progressionTips: "Increase 5 lbs when you hit 12 reps easily. Goal: 40+ lbs"
      },
      {
        id: 5,
        name: "Tricep Pushdown (Cable)",
        sets: 4,
        reps: "12-15",
        rest: "60 sec",
        notes: "Start 40-50 lbs. Builds back of arms. Critical for arm thickness",
        machine: "Cable machine with rope or bar attachment",
        progressionTips: "Focus on full extension and squeeze at bottom"
      },
      {
        id: 6,
        name: "Face Pulls (Cable)",
        sets: 3,
        reps: "15-20",
        rest: "45 sec",
        notes: "Light weight (30-40 lbs). Pull rope to face, elbows high. Builds rear delts and shoulder health",
        machine: "Cable machine at face height with rope",
        progressionTips: "Essential for balanced shoulder development"
      }
    ]
  },

  // Friday: Bodyweight Full Body + Core (5am, 45-60 min)
  friday: {
    name: "Bodyweight Full Body Power",
    time: "5:00 AM",
    duration: "45-60 min",
    location: "Home",
    focus: "Full Body, Power, Core",
    exercises: [
      {
        id: 1,
        name: "Burpees",
        sets: 4,
        reps: "10-12",
        rest: "90 sec",
        notes: "Full body exercise. Builds military functional fitness",
        progressionTips: "Progress to burpee + pull-up combo"
      },
      {
        id: 2,
        name: "Pull-ups",
        sets: 5,
        reps: "Max reps",
        rest: "2-3 min",
        notes: "Maximum effort. Track your numbers - you'll see progress weekly",
        progressionTips: "Goal: 8-10 pull-ups by month 3"
      },
      {
        id: 3,
        name: "Diamond Push-ups",
        sets: 4,
        reps: "8-12",
        rest: "90 sec",
        notes: "Hands together in diamond shape. Great for triceps and inner chest",
        progressionTips: "Progress to decline diamond push-ups"
      },
      {
        id: 4,
        name: "Jump Squats",
        sets: 4,
        reps: "12-15",
        rest: "60 sec",
        notes: "Explosive power. Builds athletic legs",
        progressionTips: "Focus on landing softly and immediately jumping again"
      },
      {
        id: 5,
        name: "Mountain Climbers",
        sets: 4,
        reps: "30 sec",
        rest: "45 sec",
        notes: "Cardio + core. Keep hips low",
        progressionTips: "Increase to 45 sec sets"
      },
      {
        id: 6,
        name: "Hollow Body Hold",
        sets: 3,
        reps: "30-45 sec",
        rest: "60 sec",
        notes: "Lie on back, arms overhead, legs straight, lift shoulders and legs off ground. Army core builder",
        progressionTips: "Work up to 60 sec holds"
      },
      {
        id: 7,
        name: "Sit-ups",
        sets: 3,
        reps: "25-30",
        rest: "45 sec",
        notes: "Classic Army PT. Full sit-ups",
        progressionTips: "Add weight behind head"
      }
    ]
  },

  // Saturday: Active Recovery / Optional Peloton (Flexible)
  saturday: {
    name: "Active Recovery - Peloton or Easy Run",
    time: "Flexible",
    duration: "30-45 min",
    location: "Home",
    focus: "Recovery, Cardio",
    exercises: [
      {
        id: 1,
        name: "Peloton Ride (Low-Moderate Intensity)",
        sets: 1,
        reps: "30-45 min",
        rest: "n/a",
        notes: "Zone 2 cardio. Should be able to hold conversation. Helps recovery and maintains fitness",
        progressionTips: "Mix in 45-60 min rides"
      },
      {
        id: 2,
        name: "OR Easy Run",
        sets: 1,
        reps: "2-3 miles",
        rest: "n/a",
        notes: "Conversational pace. Enjoy the movement",
        progressionTips: "Build to 3-4 miles"
      },
      {
        id: 3,
        name: "Stretching/Mobility",
        sets: 1,
        reps: "10-15 min",
        rest: "n/a",
        notes: "Focus on hips, shoulders, hamstrings. Critical for recovery",
        progressionTips: "Consider yoga or dedicated mobility routine"
      }
    ]
  },

  // Sunday: Rest or Optional Cardio
  sunday: {
    name: "Rest Day or Light Cardio",
    time: "Flexible",
    duration: "Optional",
    location: "Home/Outside",
    focus: "Recovery",
    exercises: [
      {
        id: 1,
        name: "Complete Rest",
        sets: 1,
        reps: "All day",
        rest: "n/a",
        notes: "Your body grows during rest. Take it seriously",
        progressionTips: "Listen to your body"
      },
      {
        id: 2,
        name: "OR Light Walk/Peloton",
        sets: 1,
        reps: "20-30 min",
        rest: "n/a",
        notes: "If you feel good, light movement is fine",
        progressionTips: "Keep it easy - recovery is the goal"
      }
    ]
  }
};

// Progress tracking milestones
export const progressGoals = {
  pullUps: {
    current: 3,
    week4: 5,
    week8: 8,
    week12: 10
  },
  pushUps: {
    current: 15,
    week4: 20,
    week8: 25,
    week12: 30
  },
  bodyFat: {
    current: 20,
    week8: 18,
    week16: 15
  },
  measurements: {
    arms: "Track weekly - goal: +1 inch in 12 weeks",
    chest: "Track weekly - goal: +2 inches, firmer",
    shoulders: "Track weekly - goal: visible definition",
    thighs: "Track weekly - goal: +1 inch, more defined"
  }
};

// Planet Fitness machine finder
export const planetFitnessMachines = {
  legPress: {
    name: "Leg Press",
    howToFind: "Usually in the corner or against a wall. Big angled seat with platform for feet",
    setup: "Adjust seat so knees are 90 degrees when feet on platform. Start light!",
    image: "leg-press-machine"
  },
  chestPress: {
    name: "Chest Press Machine",
    howToFind: "Looks like a bench with handles at chest level",
    setup: "Handles should be at mid-chest level. Adjust seat height",
    image: "chest-press-machine"
  },
  shoulderPress: {
    name: "Shoulder Press",
    howToFind: "Handles start at shoulder height, push up overhead",
    setup: "Seat height: handles at shoulder level when seated",
    image: "shoulder-press-machine"
  },
  seatedRow: {
    name: "Seated Cable Row",
    howToFind: "Sit facing cable machine, pull to torso",
    setup: "Feet on platform, slight bend in knees, upright torso",
    image: "seated-row-machine"
  },
  lateralRaise: {
    name: "Lateral Raise Machine",
    howToFind: "Pads on outside of arms, push arms out to sides",
    setup: "Adjust seat so pads hit mid-upper arm",
    image: "lateral-raise-machine"
  },
  assistedPullup: {
    name: "Assisted Pull-up Machine",
    howToFind: "Platform to kneel on, pull-up bars above",
    setup: "More weight = more assistance. Start high (80-100 lbs assist)",
    image: "assisted-pullup-machine"
  }
};

// Nutrition guidelines (simple, focused on your goals)
export const nutritionGuidelines = {
  protein: {
    target: "140-175g per day",
    why: "Build muscle and maintain lean mass",
    sources: "Chicken, fish, eggs, Greek yogurt, protein shakes"
  },
  calories: {
    target: "2200-2400 per day",
    why: "Slight surplus to build muscle while staying lean. You've lost the fat, now build the muscle",
    note: "Track roughly. Don't need to be perfect"
  },
  tips: [
    "Protein shake after workouts (30-40g protein)",
    "Eat protein at every meal",
    "Don't fear carbs - you need them for energy and muscle building",
    "Stay hydrated - 80-100 oz water daily",
    "Sleep 7-8 hours - critical for muscle recovery"
  ]
};
